import styled from '@emotion/styled';
import type { SetRequired } from 'type-fest';

import { createClassNames } from '@hrworks/design-system/functions';
import { overflowHyphens } from '@hrworks/design-system/utilities';

import type { HelpTextProps } from './HelpText.types';

const HelpTextContainer = styled.span<SetRequired<HelpTextProps, 'size'>>(
  ({ theme, validationState, validationMessage, size }) => [
    overflowHyphens,
    {
      ...theme.eclipseTier2Typography.bodySm,
      display: 'inline-block',
      fontSize: '0.875em',
      marginTop: theme.marko.variables.spacing.formGap[size],
      color: theme.eclipseTier2Color.text.info.default,
      ...(validationState &&
        validationMessage && {
          color: theme.eclipseTier2Color.text[validationState === 'danger' ? 'error' : validationState].default,
        }),
    },
  ],
);

const components = { HelpTextContainer };

export const S = {
  ...components,
  ...createClassNames('HelpText', components),
} as const;
